import { render, staticRenderFns } from "./GroupSettings.vue?vue&type=template&id=9ba26c9c"
import script from "./GroupSettings.vue?vue&type=script&lang=js"
export * from "./GroupSettings.vue?vue&type=script&lang=js"
import style0 from "./GroupSettings.vue?vue&type=style&index=0&id=9ba26c9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports